import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/admin/login', { email, password }),
  createAdmin: (email, password) => api.post('/admin/create', null, { params: { email, password } }),
};

// Blog API
export const blogAPI = {
  getAll: (publishedOnly = true) => api.get('/blogs', { params: { published_only: publishedOnly } }),
  getBySlug: (slug) => api.get(`/blogs/${slug}`),
  create: (data) => api.post('/blogs', data),
  update: (id, data) => api.put(`/blogs/${id}`, data),
  delete: (id) => api.delete(`/blogs/${id}`),
};

// Project API
export const projectAPI = {
  getAll: (category = null) => api.get('/projects', { params: category ? { category } : {} }),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
};

// Appointment API
export const appointmentAPI = {
  create: (data) => api.post('/appointments', data),
  getAll: (dateFilter = null) => api.get('/appointments', { params: dateFilter ? { date_filter: dateFilter } : {} }),
  getAvailableSlots: (date) => api.get('/appointments/available-slots', { params: { date } }),
  cancel: (id) => api.patch(`/appointments/${id}/cancel`),
  approve: (id) => api.patch(`/appointments/${id}/approve`),
  complete: (id) => api.patch(`/appointments/${id}/complete`),
  cancel: (id) => api.patch(`/appointments/${id}/cancel`),
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

// Admin Stats API
export const adminAPI = {
  getStats: () => api.get('/admin/stats'),
};

export const surveyAPI = {
  submit: (data) => api.post('/survey', data),
  getAll: () => api.get('/admin/surveys'),
};
